class PriveHotspotLook {
  constructor(root) {
    this.root = root;
    this.hotspots = Array.from(root.querySelectorAll('[data-prive-hotspot-index]'));
    this.sliderEl = root.querySelector('[data-prive-hotspot-slider]');
    this.paginationEl = root.querySelector('[data-prive-hotspot-pagination]');

    if (!this.sliderEl || this.hotspots.length === 0 || typeof Swiper === 'undefined') return;

    this.swiper = new Swiper(this.sliderEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 450,
      autoHeight: true,
      allowTouchMove: true,
      pagination: {
        el: this.paginationEl,
        clickable: true,
        bulletClass: 'prive-hotspot-look__bullet',
        bulletActiveClass: 'is-active',
        renderBullet: (index, className) => {
          return `<button type="button" class="${className}" aria-label="Show product ${index + 1}"></button>`;
        },
      },
      on: {
        init: (swiper) => this.setActiveHotspot(swiper.activeIndex),
        slideChange: (swiper) => this.setActiveHotspot(swiper.activeIndex),
      },
    });

    this.hotspots.forEach((hotspot) => {
      const index = Number(hotspot.dataset.priveHotspotIndex);

      hotspot.addEventListener('mouseenter', () => {
        this.swiper.slideTo(index);
      });

      hotspot.addEventListener('focus', () => {
        this.swiper.slideTo(index);
      });

      hotspot.addEventListener('click', (event) => {
        if (window.matchMedia('(hover: none)').matches) {
          if (!hotspot.classList.contains('is-active')) {
            event.preventDefault();
            this.swiper.slideTo(index);
          }
        }
      });
    });
  }

  setActiveHotspot(index) {
    this.hotspots.forEach((hotspot, hotspotIndex) => {
      hotspot.classList.toggle('is-active', hotspotIndex === index);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-prive-hotspot-look]').forEach((root) => {
    new PriveHotspotLook(root);
  });
});
